<div mat-dialog-title class="cust-modal-title">
  <h2 class="m-0">{{ parentData.title }}</h2>
  <button mat-icon-button mat-dialog-close>
     <mat-icon>close</mat-icon>
  </button>
</div>
<mat-dialog-content>
  <div>
     <mat-form-field appearance="outline" style="width: 100%">
        <mat-label>Name</mat-label>
        <input [(ngModel)]="newbookingData.customerName" matInput />
     </mat-form-field>
  </div>
  <div class="row g-2  justify-content-between phone-field">
     <mat-form-field appearance="outline" class="country-code col-3">
        <mat-label>Country Code</mat-label>
        <mat-select
        [(ngModel)]="selectedCountryCode"
        required
        (selectionChange)="onCountrySelected($event)"
        >
        <mat-select-trigger>
           {{ selectedCountryCode.flag }} {{ selectedCountryCode.name }}
           {{ "(" + selectedCountryCode.dial_code + ")" }}
        </mat-select-trigger>
        <mat-option>
           <ngx-mat-select-search
           noEntriesFoundLabel="no results found"
           name="search"
           placeholderLabel="Enter country name"
           [formControl]="searchString"
           (keyup)="onKey()"
           ></ngx-mat-select-search>
        </mat-option>
        <mat-option *ngFor="let country of countryList" [value]="country">
        {{ country.flag }} {{ country.name }}
        {{ "(" + country.dial_code + ")" }}
        </mat-option>
        </mat-select>
     </mat-form-field>
     <mat-form-field class="mobile_form col-9" appearance="outline" >
        <mat-label>Phone</mat-label>
        <input [(ngModel)]="newbookingData.customerPh" matInput  type="tel" smNumericOnly
        minLength="3"
        maxlength="17">
        <mat-hint style="color: red;
           font-size: 13px;" align="end" *ngIf="newbookingData.customerPh && newbookingData.customerPh != '' &&  newbookingData.customerPh.length < 3 ">Enter a valid phone number.</mat-hint>
     </mat-form-field>
  </div>
  <div style="padding-left: 5px;">
     <h3 style="margin-bottom:5px">Opted services</h3>
     <div style="color: #f2b600;
        font-weight: 500;
        font-size: 16px;">
        <p>{{parentData.data.bookingData.serviceInfo | servicesToStr}}</p>
     </div>
  </div>
  <div class="chip_cont" style="padding: 20px 0px;">
     <mat-chip-listbox class="example-chip" *ngIf="serviceList.length > 0">
        <div *ngFor="let item of serviceList">
           <mat-chip
           *ngIf="item.toShow"
           
           (click)="selectServices(item)"
           >{{ item.serviceName }}
           </mat-chip>
        </div>
     </mat-chip-listbox>
     <p *ngIf="serviceList.length == 0">No service added</p>
  </div>
  <!-- PRODUCTS -->
  <h3 class="servicet_heading" *ngIf="productsList.length > 0"> Sellable products</h3>
  <div class="chip_cont" style="padding: 20px 0px;" *ngIf="productsList.length > 0">
     <mat-chip-listbox class="example-chip" *ngIf="productsList.length > 0">
        <div *ngFor="let item of productsList">
           <mat-chip
           *ngIf="item.toShow"
           
           (click)="selectProducts(item)"
           >{{ item.product_name }}
           </mat-chip>
        </div>
     </mat-chip-listbox>
     <p *ngIf="serviceList.length == 0">No service added</p>
  </div>
  <!-- COMPLETED JOBS -->
  <div style="padding-left: 5px;    margin-bottom: 30px;">
     <h3 style="color: #222; font-weight: bold;" *ngIf="completedJobs.length > 0">Job completed</h3>
     <div class="" *ngIf="completedJobs.length > 0">
        <div class="job_complete_section" *ngFor="let item of completedJobs; let i = index;" style="margin-bottom: 30px;">
           <div
              style="
              display: inline-block;
              width: fit-content;
              background: #ffc107;
              padding: 8px 20px;
              border-radius: 34px;
              margin-bottom: 20px;
              margin-right: 12px; ">
              <p style="margin: 0px; font-weight: 500; font-size: 16px">
                 {{ item.serviceName }}
              </p>
           </div>
           <div class="produce_bill_sec">
           <div style="display: inline-block;">
              <span style="margin-left: 0px;border: 1px solid #a2a2a2; padding: 10px; margin-bottom: 10px;display: block;border-radius: 10px;">
                 <button
                    (click)="decreaseServiceCount(item,i)"
                    style="background: none;
                    border: 1px solid #a2a2a2;
                    border-radius: 25px;
                    width: 25px;
                    height: 25px;">
                    <mat-icon class="material-icons-outlined" style="    font-size: 16px;
                       position: relative;
                       top: 2px;
                       left: -3px;
                       color: #666666;
                       height: auto;
                       width: auto;">remove</mat-icon>
                 </button>
                 <span style="margin: 0 15px;"> {{item.total_completed_services_qty}} </span>
                 <button 
                    (click)="increaseServiceCount(item,i)"
                    style="background: none;
                    border: 1px solid #a2a2a2;
                    border-radius: 25px;
                    width: 25px;
                    height: 25px;">
                    <mat-icon style="    font-size: 16px;
                       position: relative;
                       top: 2px;
                       left: -3px;
                       color: #666666;
                       height: auto;
                       width: auto;" class="material-icons-outlined">add</mat-icon>
                 </button>
              </span>
           </div>
         </div>
         <div class="profi_section_remove">
            <div class="by_tt" *ngIf="isOwner"> 
              by <span (click)="assignEmployee(item,i)" >{{item.completed_by | arrayToStr | ellipsify:30}}</span>
            </div>
            <div class="remove_tt">
              <span
                 (click)="removeCompletedJobs(item)"
                 style="
                 margin-left: 20px;
                 display: inline-block;
                 cursor: pointer;">
              Remove
              </span>
            </div>
           </div>
        </div>
     </div>
  </div>
  <!-- COMPLETED PRODUCTS -->
  <div style="padding-left: 5px;    margin-bottom: 30px;">
     <h3 style="color: #222; font-weight: bold;" *ngIf="completedProducts.length > 0">Products selected</h3>
     <div class="" *ngIf="completedProducts.length > 0">
        <div class="job_complete_section" *ngFor="let item of completedProducts; let i = index;" style="margin-bottom: 30px;">
           <div
              style="
              display: inline-block;
              width: fit-content;
              background: #ffc107;
              padding: 8px 20px;
              border-radius: 34px;
              margin-bottom: 20px;
              margin-right: 12px;
              "
              >
              <p style="margin: 0px; font-weight: 500; font-size: 16px">
                 {{ item.product_name }}
              </p>
           </div>
           <!-- <mat-icon style="    font-size: 20px;
              font-weight: 900;
              color: #000;
              position: relative;
              top: 4px;
              display: none;
              margin-left: 10px;">close</mat-icon> -->
              <div class="produce_bill_sec">
           <div style="display: inline-block;">
              <span style="    margin-left: 0px;
                 border: 1px solid #a2a2a2;
                 padding: 10px;
                 margin-bottom: 10px;
                 display: block;
                 border-radius: 10px;">
                 <button
                    (click)="decreaseProductCount(item,i)"
                    style="background: none;
                    border: 1px solid #a2a2a2;
                    border-radius: 25px;
                    width: 25px;
                    height: 25px;">
                    <mat-icon class="material-icons-outlined" style="    font-size: 16px;
                       position: relative;
                       top: 2px;
                       left: -3px;
                       color: #666666;
                       height: auto;
                       width: auto;">remove</mat-icon>
                 </button>
                 <span style="margin: 0 15px;"> {{item.product_qty}} </span>
                 <button 
                    (click)="increaseProductCount(item,i)"
                    style="background: none;
                    border: 1px solid #a2a2a2;
                    border-radius: 25px;
                    width: 25px;
                    height: 25px;">
                    <mat-icon style="    font-size: 16px;
                       position: relative;
                       top: 2px;
                       left: -3px;
                       color: #666666;
                       height: auto;
                       width: auto;" class="material-icons-outlined">add</mat-icon>
                 </button>
              </span>
           </div>
              </div>
              <div class="profi_section_remove" style="justify-content: flex-end;">
              <span (click)="removeCompletedProducts(item)" style="  margin-left: 20px; display: inline-block; cursor: pointer;"> Remove
              </span>
           </div>
        </div>
     </div>
  </div>
  <!-- create invice new design added -->
  <div class="other_itemi_secty">
     <div class="oth_headingrt">
        <h3>Other item</h3>
     </div>
     <form [formGroup]="form">
        <div formArrayName="items">
           <div *ngFor="let item of items.controls; let i = index" [formGroupName]="i" class="repect_under">
           <div class="row">
              <div class="col-sm-3">
                 <div class="item_name_tht">
                    <mat-form-field appearance="outline" class="full-width">
                       <mat-label>Item name</mat-label>
                       <input matInput formControlName="name" [matAutocomplete]="auto" type="text" placeholder="Enter item name">
                       <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayItemName">
                       <mat-option *ngFor="let option of filteredOptions[i] | async" [value]="option">
                       {{ option.item_name }}
                       </mat-option>
                       </mat-autocomplete>
                    </mat-form-field>
                 </div>
              </div>
              <div class="col-sm-3">
               <mat-form-field appearance="outline" >
                  <mat-select class="w-100" formControlName="tax_slab">
                     <mat-option value="default" >
                        Select a tax
                     </mat-option>
                     <mat-option [value]="item.hash_id" *ngFor="let item of taxSlabData">
                     {{isEntityForeign == '0' ? item.tax_name : item.slab_name}}
                     </mat-option>
                  </mat-select>
               </mat-form-field>
            </div>
              <div class="afsf">
                 <div class="plus_tht newclassw">
                    <div class="flexsc">
                  <div class="inc_dec_cont">
                       <span class="cont_span" style="top: 0px;border: 1px solid #a2a2a2;padding: 13px !important;border-radius: 10px; position: relative; bottom: 0px;  width: 125px; display: block;  margin-right: 10px;">
                          <button type="button" class="inc_dec_btn"  (click)="decreaseCount(i)">
                             <mat-icon>remove</mat-icon>
                          </button>
                          <span style="margin: 0 15px;">{{ item.get('count')!.value }}</span>
                          <button type="button" class="inc_dec_btn"  (click)="increaseCount(i)">
                             <mat-icon>add</mat-icon>
                          </button>
                       </span>
                    </div>
                  </div>

                    <div class="item_name_tht itempricex">
                     <mat-form-field appearance="outline">
                        <mat-label>Item price</mat-label>
                        <input matInput formControlName="price" placeholder="Enter item price" smDecimalOnly  type="number" >
                     </mat-form-field>
                  </div>
                 </div>
              </div>
              <span class="remove_btn" (click)="removeFormField(i)">Remove</span>
           </div>
        </div>
  </div>
  <div class="add_item_btbh">
  <button type="button" mat-flat-button color="accent" (click)="addFormField()">
  <mat-icon>add</mat-icon>
  Add item
  </button>
  </div>
  </form>
  </div>
  <!-- create invice new design end -->
  <div>
     <mat-form-field appearance="outline" style="width: 100%">
        <mat-label>Cost</mat-label>
        <input [(ngModel)]="formattedPrice" matInput  [disabled]="true"/>
     </mat-form-field>
  </div>
  <div>
     <mat-form-field appearance="outline" style="width: 100%">
        <mat-label>Notes</mat-label>
        <textarea [(ngModel)]="newbookingData.note" matInput></textarea>
        <!-- <mat-icon matSuffix class="material-icons-outlined">message</mat-icon> -->
     </mat-form-field>
  </div>
</mat-dialog-content>
<div class="customize_footer" align="end">
  <div class="all_button_sung">
    <div class="button_yyt" style="margin-bottom: 10px;">
  <button
  mat-button 
  style="    border: 1px solid #ffc107;
    color: #ffc107;"
  (click)="allDoneAndRelease()"
  
  >
  All done and release
  </button>
    </div>
    <div class="button_yyt" >
  <button mat-button   style="    border: 1px solid #ffc107;
    color: #ffc107;" 
  (click)="partiallyDone()"
  >Partially done and release</button>
    </div>

  </div>
  <div class="active_button_yyt">
    <button
    mat-flat-button
    color="accent"
    (click)="onPost()"
    
    >
    All done and produce bill
    </button>
  </div>
</div>